import { useQuery } from "@tanstack/react-query";

import { listOneCBases, ONEC_BASES_QUERY_KEY, type OneCBase, type OneCBaseList } from "@/api/onec_bases";

/** Справочник баз 1С + состояние сессии. Один ключ на индикатор в шапке,
 *  выбор базы и админ-страницу: выбор базы обновляет кэш, и шапка сразу
 *  показывает новую действующую базу. */
export function useOneCBases() {
  return useQuery({ queryKey: ONEC_BASES_QUERY_KEY, queryFn: listOneCBases });
}

/** Что мешает SSO-сессии ходить в 1С; null — доступ настроен. Те же два
 *  условия, по которым бэкенд отвечает 403 `onec_not_configured` /
 *  `onec_base_not_configured` (`one_c_hs/dependencies.py`). */
export function ssoOneCProblem(data: OneCBaseList): string | null {
  if (!data.has_onec_unf) {
    return "В учётной записи SSO не указан пользователь 1С (onec_unf) — обратитесь к администратору.";
  }
  if (data.effective_id === null) {
    return "В справочнике нет базы 1С по умолчанию, и база не выбрана — обратитесь к администратору портала.";
  }
  return null;
}

/** Подпись действующей базы. `effective_id` есть, а базы в списке нет —
 *  рассинхрон ответа: говорим об этом текстом, а не бросаем в рендере
 *  (ErrorBoundary в портале нет — упал бы весь экран, см. `settingsNavItems`). */
export function effectiveBaseName(data: OneCBaseList): string | null {
  if (data.effective_id === null) return null;
  const base: OneCBase | undefined = data.bases.find((b) => b.id === data.effective_id);
  return base ? base.name : `⚠ база ${data.effective_id} не найдена в справочнике`;
}
